import { CommonModule } from '@angular/common';
import { HttpClient,  HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { CalendarModule } from 'angular-calendar';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { ModalModule } from 'ngx-bootstrap';

// Component
// import { DashboardComponent } from './dashboard/dashboard.component';
import { HomeComponent } from './home.component';
import { HomeRoutingModule } from './home-routing.module';
import { ScheduleComponent, ScheduleService } from './schedule';

// Helper
import { DateHelper, DialogHelper, ExceptionHelper, UserStorage } from './../../helper';

// Module
import { CustomerModule } from './customer';
import { SiteModule } from './site';
import { EquipmentModule } from './equipment';
import { PreventiveMaintenanceModule } from './preventive-maintenance';
import { ProductCategoryModule } from './product-category';
import { ChangePasswordComponent, ChangePasswordService } from './change-password';
import { UserModule } from './user';
import { ServiceCallModule } from './service-call';
import { EcallModule } from './ecall';
// import { SurveyModule } from './survey';
import { ReportModule } from './report';

// Import components
import {
  AppAsideComponent,
  AppBreadcrumbsComponent,
  AppFooterComponent,
  AppHeaderComponent,
  AppSidebarComponent, AppSidebarFooterComponent, AppSidebarFormComponent, AppSidebarHeaderComponent, AppSidebarMinimizerComponent,
  APP_SIDEBAR_NAV
} from '../../components';

const APP_COMPONENTS = [
  AppAsideComponent,
  AppBreadcrumbsComponent,
  AppFooterComponent,
  AppHeaderComponent,
  AppSidebarComponent, AppSidebarFooterComponent, AppSidebarFormComponent, AppSidebarHeaderComponent, AppSidebarMinimizerComponent,
  APP_SIDEBAR_NAV
];

// Import directives
import {
  AsideToggleDirective,
  NAV_DROPDOWN_DIRECTIVES,
  ReplaceDirective,
  SIDEBAR_TOGGLE_DIRECTIVES
} from '../../directives';
import { ContractModule } from './contract/contract.module';

const APP_DIRECTIVES = [
  AsideToggleDirective,
  NAV_DROPDOWN_DIRECTIVES,
  ReplaceDirective,
  SIDEBAR_TOGGLE_DIRECTIVES
];


export function HttpLoaderFactory(httpClient: HttpClient) {
    return new TranslateHttpLoader(httpClient);
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    HttpModule,
    
    HomeRoutingModule,
    ChartsModule,
    // DataTablesModule.forRoot(),
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    TabsModule.forRoot(),
    TabsModule.forRoot(),
    CalendarModule.forRoot(),
    TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient]
        }
    }),
    PreventiveMaintenanceModule,
    ProductCategoryModule,
    UserModule,
    CustomerModule,
    SiteModule,
    EquipmentModule,
    ReportModule,
    // SurveyModule,
    ServiceCallModule,
    EcallModule,
    ContractModule
  ],
  declarations: [
    ChangePasswordComponent,
    // DashboardComponent,
    HomeComponent,
    ScheduleComponent,
    ...APP_COMPONENTS,
    ...APP_DIRECTIVES,
  ],
  providers: [
    ChangePasswordService,
    ScheduleService,
    DateHelper,
    DialogHelper,
    ExceptionHelper,
    UserStorage,
    DateHelper
  ]
})

export class HomeModule { }



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/home.module.ts